var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-middle-cmp"},[_c('div',{staticClass:"echartsBody",attrs:{"id":_vm.comID}})])
}
var staticRenderFns = []

export { render, staticRenderFns }